export default __webpack_public_path__ + "6f8e028848c26c8d5c32758538d34c1a.png";